import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: false,
};

export const userLoadingSlice = createSlice({
  name: "userLoading",
  initialState,
  reducers: {
    setUserLoading: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserLoading } = userLoadingSlice.actions;

export default userLoadingSlice.reducer;
